import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";
import Toasted from "vue-toasted";
//import CKEditor from '@ckeditor/ckeditor5-vue';
import CKEditor from "ckeditor4-vue";
import TableHeader from "@/components/TableHeader";
import MultiSelect from "@/components/MultiSelect";
import MultiSelectInput from "@/components/MultiSelectInput";
import InputError from "@/components/InputError";
import AlertBox from "@/components/coordinator/Alert-Box";
import PhoneNumber from "@/components/PhoneNumber";
import OtpInput from "@bachdgvn/vue-otp-input";
import OTPModal from "@/components/OTPModal";
import Paginate from "vuejs-paginate";
import Pagination from "@/components/Pagination";
import Helper from "@/utils/helper.js";
import constants from "@/utils/constants.js";
// import VuePaginateAl from 'vue-paginate-al';
import { WebCam } from "vue-web-cam";
import VueApexCharts from "vue-apexcharts";
import PinchZoom from "vue-pinch-zoom";
import VueCookies from "vue-cookies";
import VueTouch from "vue-touch";
import LazyTube from "vue-lazytube";
import VueYoutube from 'vue-youtube'
import device from 'vue-device-detector-js'
import vueInsomnia from "vue-insomnia";
import VueNumber from 'vue-number-animation'


Vue.component("pinch-zoom", PinchZoom);
Vue.component("vue-web-cam", WebCam);
Vue.component("apexchart", VueApexCharts);
Vue.component("TableHeader", TableHeader);
Vue.component("AlertBox", AlertBox);
Vue.component("InputError", InputError);
Vue.component("PhoneNumber", PhoneNumber);
Vue.component("OTPModal", OTPModal);
Vue.component("paginate", Paginate);
Vue.component("Pagination", Pagination);
// Vue.component('vue-paginate-al', VuePaginateAl)
Vue.component("v-otp-input", OtpInput);
Vue.component("multi-select", MultiSelect);
Vue.component("multi-select-input", MultiSelectInput);
// Vue.use(VueGoogleCharts)
Vue.use(CKEditor);
Vue.use(VueMaterial);
Vue.use(VueCookies);
Vue.use(Toasted, {
  duration: 4000,
  position: "bottom-left",
  keepOnHover: true,
  // theme:'bubble',
  containerClass: "toasted-overlay",
  action: {
    icon: "mdiclose",
    onClick: (e, toastObject) => {
      toastObject.goAway(0);
    },
  },
});
Vue.use(VueTouch, { name: "v-touch" });
Vue.use(LazyTube);
Vue.use(VueYoutube);
Vue.use(vueInsomnia);
Vue.use(VueNumber)

Vue.config.productionTip = false;

Vue.directive("click-outside-view", {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
});
Vue.use(device)

Vue.mixin({
  methods: Helper,
  data: function() {
    return {
      get editorURL() {
        return `${window.location.protocol}//${window.location.host}/ckeditor/ckeditor.js`;
        //return "http://localhost:8080/ckeditor/ckeditor.js";
      },
      roles: constants.ROLES,
      modes: constants.MODES,
      roleIds: constants.ROLES_ID,
      types: constants.TYPES,
      TEST_SUB_TYPES: constants.TEST_SUB_TYPES,
      QUE_TYPES: constants.QUE_TYPES,
      OPTIONS_ABC: constants.OPTIONS_ABC,
      OPTIONS_PQR: constants.OPTIONS_PQR,
      QUESTION_STATUS_COLOR: constants.QUESTION_STATUS_COLOR,
      QUESTION_STATUS: constants.QUESTION_STATUS,
      TEST_TYPE: constants.TEST_TYPE,
      QUESTION_ACTIONS: constants.QUESTION_ACTIONS,
      QUESTION_ACTIVITY: constants.QUESTION_ACTIVITY,
      QUESTION_ENTITY: constants.QUESTION_ENTITY,
      PAST_QUESTION_STATUS: constants.PAST_QUESTION_STATUS,
      PAST_QUESTION_COLOR: constants.PAST_QUESTION_COLOR,
      HEART_BEAT_TIME: constants.HEART_BEAT_TIME,
      STUDENT_HEALTH_PERCENTAGE_COLOR:
        constants.STUDENT_HEALTH_PERCENTAGE_COLOR,
      TESTWISEANALYSIS_TEST_TYPES: constants.TESTWISEANALYSIS_TEST_TYPES,
      DUMMYTEXT: constants.DUMMYTEXT,
      ERROR_CODES: constants.ERROR_CODES,
      USER_ATTEMPT_STATUS: constants.USER_ATTEMPT_STATUS,
      BONUS_MESSAGE: constants.BONUS_MESSAGE,
      UNSUPPROTED_BROWSERS: constants.UNSUPPROTED_BROWSERS,
      CUSTOM_DOMAINS: constants.CUSTOM_DOMAINS,
      ALTI_TITLE: constants.ALTI_TITLE,
      YOUTUBE_SEARCH_API_KEY: constants.YOUTUBE_SEARCH_API_KEY,
      COOKIE_PATH: constants.COOKIE_PATH,
      COOKIE_DOMAIN: constants.COOKEI_DOMAIN,
      ONLINE_INSTITUTE_ID: constants.ONLINE_INSTITUTE_ID,
      CUSTOM_INSTITUTE_ID: constants.CUSTOM_INSTITUTE_ID,
      OMR_SUPPORTED_FILE_TYPES: constants.OMR_SUPPORTED_FILE_TYPES,
      AITS_INSTITUTE_ID: constants.AITS_INSTITUTE_ID,
      DOWNLOAD_STATUS:constants.DOWNLOAD_STATUS
    };
  },
});

Vue.config.errorHandler = (err, vm, info) => {
  console.log(err, info);
  newrelic.noticeError(err, info);
};

window.onerror = function(message, source, lineno, colno, error) {
  console.log(error, message, source, lineno, colno);
  newrelic.noticeError(error, message, source, lineno, colno);
};

new Vue({
  data() {
    return {
      showLoader: false,
      showLoaderIndex: 1000,
    };
  },
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
